import { memo } from "react";
import { CaretDownOutlined } from "@ant-design/icons";

const DropdownIcon = (props) => <CaretDownOutlined {...props} style={{ color: "#474747" }} />;

export default memo(DropdownIcon);
